import React,{ useState, useEffect, useRef } from "react";
import { 
    Form, 
    Input,
    Button,
    Radio,
    Checkbox
} from 'antd';
import MaskedInput from "antd-mask-input";
import axios from 'axios';

import { 
    CheckCircleOutlined,
    CloseCircleOutlined
} from '@ant-design/icons';

function ContactInfo( {
    setFirstNameValid,
    setLastNameValid,
    setPhoneNumberValid,
    setEmailValid,
    setFirstName,
    setLastName,
    setEmail,
    setPhone,
    setCanContactCustomer,
    setContactInfoComponentCompleted,
    setProgressCount,
    setLineType,
    currentStep,
    firstName,
    lastName,
    email,
    phone,
    lineType,
    canContactCustomer,
    cartHasItems,
    contactInfoComponentCompleted,
    firstNameValid,
    lastNameValid,
    emailValid,
    phoneNumberValid,
    paymentReceived,
    isD2C
    } ) {

    const [firstNameValidSuffix, setFirstNameValidSuffix] = useState(<></>);
    const [lastNameValidSuffix, setLastNameValidSuffix] = useState(<></>);
    const [phoneNumberValidSuffix, setPhoneNumberValidSuffix] = useState(<></>);
    const [emailValidSuffix, setEmailValidSuffix] = useState(<></>);

    const siteDomain = headerVars.siteDomain;
    const mounted = useRef();

    useEffect(() => {
        if( headerVars.orderNumber ) {
            validateInput(firstName, 'contact-info-first-name');
            validateInput(lastName, 'contact-info-last-name');
            validateInput(phone, 'contact-info-phone-number');
            validateInput(email, 'contact-info-email');
        }
    },[])

    const handleOnNextStepClick = ( e ) => {
        setContactInfoComponentCompleted(true);
        setProgressCount(1);

        let qualificationData = getCookie('qualification-data');
        let qualificationDataStr = decodeURIComponent( qualificationData );
        let qualificationDataJSON = qualificationDataStr.replace(/\\/g, '');
        let qualificationDataObj = JSON.parse( qualificationDataJSON );
        let qualifiedAddress = qualificationDataObj.address.address_string;
        
        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};
        let form_data = new FormData;
        form_data.append('action', 'setup_initial_wc_order');
        form_data.append('customer_name', firstName + ' ' + lastName );
        form_data.append('customer_first_name', firstName );
        form_data.append('customer_last_name', lastName );
        form_data.append('customer_email', email);
        form_data.append('customer_phone', phone);
        form_data.append('service_address', qualifiedAddress );
        form_data.append('data_collection_optin', canContactCustomer);
        form_data.append('order_number', headerVars.orderNumber);
        form_data.append('line_type', lineType);

        //console.log('isD2C:: ', isD2C);

        if( isD2C ) {
            let repName = localStorage.getItem('rep-name');
            let repID = localStorage.getItem('rep-id');
            let repEmail = localStorage.getItem('rep-email');
            let dealerChannel = localStorage.getItem('dealer-channel');

            //console.log('repEmail:::: ', repEmail);

            form_data.append('rep_name', repName);
            form_data.append('rep_id', repID);
            form_data.append('rep_email', repEmail);
            form_data.append('rep_dealer_channel', dealerChannel);
            form_data.append('is_d2c', true);
        }

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            //console.log(response);
        })
        .catch(function (error) {
            console.log(error);
        })
        .finally(function () {
            // always executed 
        }); 
    }
    
    const onInfoCheckboxChange = ( e ) => {
        let checked = e.target.checked;
        //console.log( "checked: ", checked );
        setCanContactCustomer(checked);
    }

    const handleOnInputChange = ( e ) => {
        let currentVal = e.target.value;
        let inputID = e.target.id;
        validateInput( currentVal, inputID );

        if( !firstNameValid || !lastNameValid || !phoneNumberValid || !emailValid ) {
            setContactInfoComponentCompleted(false);
            setProgressCount(0);
        }
    }

    const validateInput = ( currentVal, inputId ) => {
        let isValid = true;
        let validationSuffix = <></>;

        switch( inputId ) {
            case 'contact-info-first-name': 
                if( currentVal.length < 2 ){ 
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerName = isValid ? currentVal : '';
                setFirstNameValid( isValid );
                setFirstName( customerName );
                setFirstNameValidSuffix( validationSuffix );
                
                if( !isValid ) { 
                    setContactInfoComponentCompleted(false);
                    setProgressCount(0);
                }
            break;

            case 'contact-info-last-name': 
                if( currentVal.length < 2 ){
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerLastName = isValid ? currentVal : '';

                setLastName( customerLastName );
                setLastNameValidSuffix( validationSuffix );
                setLastNameValid( isValid );

                if( !isValid ) { 
                    setContactInfoComponentCompleted(false);
                    setProgressCount(0);
                }
            break;

            case 'contact-info-phone-number': 
                if( !currentVal.match(/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im) ) {
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerPhone = isValid ? currentVal : '';

                setPhone( currentVal );
                setPhoneNumberValidSuffix( validationSuffix );
                setPhoneNumberValid( isValid );

                if( !isValid ) { 
                    setContactInfoComponentCompleted(false);
                    setProgressCount(0);
                }
            break;

            case 'contact-info-email': 
                if( !currentVal.match(/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/) ) {
                    isValid = false;
                }

                validationSuffix = isValid ? <CheckCircleOutlined style={{ color: '#52C41A' }}/> : <CloseCircleOutlined style={{ color: '#ff4545' }}/>;

                let customerEmail = isValid ? currentVal : '';

                setEmail( customerEmail );
                setEmailValidSuffix( validationSuffix );
                setEmailValid( isValid );

                if( !isValid ) { 
                    setContactInfoComponentCompleted(false);
                    setProgressCount(0);
                }
            break;
        }
    }

    const handleOnLineTypeChange = ( e ) => {
        setLineType( e.target.value );
    }

    const getComponentMarkup = () => {
        //console.log( "contactInfoComponentCompleted: ", contactInfoComponentCompleted );
        //console.log( "cartHasItems: ", cartHasItems );
        if( cartHasItems || paymentReceived ) {
            if( contactInfoComponentCompleted ) {

                return(
                    <div className="contact-info-summary-container">
                        <div className="summary-container-row">{ firstName + ' ' + lastName }</div>
                        <div className="summary-container-row">{ phone }</div>
                        <div className="summary-container-row">{ email }</div>
                    </div>
                )
            } else {
                return (
                    <Form>
                        <div className="form-column-row">
                            <Form.Item
                                label="First name"
                                labelCol={{ span: 24 }}
                                name="firstname"
                                style={{paddingRight:'1rem'}}
                                rules={[
                                    {
                                    required: true,
                                    message: 'Please input your first name!',
                                    },
                                ]}
                            >
                                <Input
                                    id="contact-info-first-name"
                                    suffix={ firstNameValidSuffix }
                                    autoFocus
                                    onChange={handleOnInputChange}
                                    defaultValue={ firstName }
                                />
                            </Form.Item>
    
                            <Form.Item
                                label="Last name"
                                name="lastname"
                                labelCol={{ span: 24 }}
                                rules={[
                                    {
                                    required: true,
                                    message: 'Please input your last name!',
                                    },
                                ]}
                            >
                                <Input 
                                    id="contact-info-last-name"
                                    suffix={ lastNameValidSuffix }
                                    onChange={handleOnInputChange}
                                    defaultValue={ lastName }
                                />
                            </Form.Item>
                        </div>
    
                        <div className="form-column-row">
                            <Form.Item
                                label="Phone number"
                                labelCol={{ span: 24 }}
                                name="phonenumber"
                                style={{paddingRight:'1rem'}}
                                rules={[
                                    {
                                    required: true,
                                    message: 'Please input your phone number!',
                                    },
                                ]}
                            >
                                <MaskedInput
                                    id="contact-info-phone-number"
                                    mask={'(000) 000-0000'}
                                    suffix={ phoneNumberValidSuffix }
                                    onChange={handleOnInputChange}
                                    defaultValue={ phone }
                                />
                            </Form.Item>
                            <Form.Item
                                label="Email address"
                                name="emailaddress"
                                labelCol={{ span: 24 }}
                                rules={[
                                    {
                                    required: true,
                                    message: 'Please input your email!',
                                    },
                                ]}
                            >
                                <Input 
                                    id="contact-info-email"
                                    suffix={ emailValidSuffix }
                                    onChange={handleOnInputChange}
                                    defaultValue={ email }
                                />
                            </Form.Item>
                        </div>
                        <div className="form-column-row">
                            <Radio.Group 
                                defaultValue={ ( lineType == 'landline' ) ? 'landline' : 'cell' } 
                                buttonStyle="solid"
                                onChange={ handleOnLineTypeChange }
                                style={{ width:'100%' }}
                            >
                                <Radio.Button
                                    value="cell">
                                    Cell</Radio.Button>
                                <Radio.Button 
                                    value="landline"
                                    >Landline</Radio.Button>
                            </Radio.Group>
                        </div>
                        <div className="form-column-row">
                            <Checkbox
                                style={{ padding:'5px', borderRadius: '8px', marginBottom: '1rem', marginTop:'1rem', width:'fit-content' }}
                                id="residential-service-confirmation-checkbox"
                                onChange={ onInfoCheckboxChange }
                                checked={ canContactCustomer }
                            >
                                I agree for my information to be collected and used in accordance to the <a href="/privacy" target="_blank">Privacy Policy</a>.
                            </Checkbox>
                        </div>
                        
                        <Button 
                            onClick={ handleOnNextStepClick } 
                            disabled={ ( firstNameValid && lastNameValid && phoneNumberValid && emailValid ) ? false : true }
                            style={ { "margin":'1rem 0', "display":"block" } }
                        >Next Step</Button>
                    </Form>
                )
            }
        }
    }

    const handleChangeContactInfo = ( e ) => {
        setContactInfoComponentCompleted( false );
    }

    const getDisplayOption = () => {

        if( contactInfoComponentCompleted && !paymentReceived && cartHasItems ) {
            return 'block'
        } else {
            return 'none'
        }
    }

    const getCookie = ( name ) => {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }
    
    return ( 
        <div className="configuration-container config-section-container">
            <div className="contact-info-folded">
                <hr />
                <div className="configuration-header-container">
                    <div class="configuration-header">
                        Contact information
                    </div>
                    
                    <div className="component-update-link" style={{"display": getDisplayOption()}}>
                        <Button 
                            type="link" 
                            class="change-info-button" 
                            style={ { display: paymentReceived ? 'none' : 'block' } }
                            onClick={ handleChangeContactInfo }>
                                Change</Button>
                    </div>
                </div>
            </div>
            { getComponentMarkup() }
            
        </div>
    )
}

export default ContactInfo